module.exports = __webpack_public_path__ + "img/avnon-3.0ee5811f.jpg";